import React, { useState, useEffect } from 'react';
import ItemSummaryCard from './ItemSummary'; // Assuming ItemSummary.js is in the same directory
import { API_BASE_URL, IMAGE_BASE_URL } from '../urldata.js';

const CategoryRow = ({ category, index }) => {
  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      const scrollAmount = container.clientWidth * 0.8;
      const target = direction === 'left' ? -scrollAmount : scrollAmount;
      const start = container.scrollLeft;
      const duration = 1200; // Slower duration (1.2s)
      let startTime = null;

      const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const fraction = Math.min(progress / duration, 1);
        const ease = easeInOutQuad(fraction);

        container.scrollLeft = start + target * ease;

        if (progress < duration) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    }
  };

  const isOdd = index % 2 !== 0;

  return (
    <div className={`category-section-wrapper ${isOdd ? 'odd' : 'even'}`}>
      <div className="container-fluid px-4">
        <div className="category-header">
          <h3 className="m-0 fs-5 fw-bold">
            <a href={`/itemlist?category=${category.id}`} className="category-title-link">
              {category.title}
            </a>
          </h3>
          <div className="category-controls">
            <a href={`/itemlist?category=${category.id}`} className="show-all-btn p-2">
              Show all
            </a>
            <button className="scroll-btn" onClick={() => scroll('left')} aria-label="Scroll left">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
              </svg>
            </button>
            <button className="scroll-btn" onClick={() => scroll('right')} aria-label="Scroll right">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>

          </div>
        </div>
        <div className="category-items-row" ref={scrollRef}>
          {category.items && category.items.map(item => (
            <div key={item.id} style={{
              flex: '0 0 auto',
              width: '240px',
              marginRight: '1rem',
              display: 'flex',
              scrollSnapAlign: 'start'
            }}>
              <ItemSummaryCard item={item} showDescription={false} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

function Topcategories() {
  const [topCategories, setTopCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTopCategories = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/tapi/topcategories`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setTopCategories(data);
      } catch (err) {
        console.error("Failed to fetch top categories:", err);
        setError(err.message || "Failed to load top categories.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchTopCategories();
  }, []);

  if (isLoading) return <div className="text-center my-4"><p>Loading top categories...</p></div>;
  if (error) return <div className="alert alert-danger" role="alert">Error: {error}</div>;
  if (!topCategories || topCategories.length === 0) return <div className="text-center my-4"><p>No top categories to display.</p></div>;

  return (
    <div className="top-categories-container mb-4">
      {topCategories.map((category, index) => (
        <CategoryRow key={category.id} category={category} index={index} />
      ))}
    </div>
  );
}

export default Topcategories;
